import { Icon, MenuPopup } from '@components/molecules'
import { MenuIconBox, MenuLink, MenuLinkWrapper } from './Table.styled'

import { noop } from 'lodash'

const TableMenu = ({ row, menuType, menus = [], onMenuClicked = noop }) => {
  return menuType === 'link' ? (
    <MenuLinkWrapper>
      {menus.map(({ id, title, icon }) => (
        <MenuLink key={`menu-${id}`} onClick={() => onMenuClicked(id, row)}>
          {icon && <Icon icon={icon} size={22} />}
          {title}
        </MenuLink>
      ))}
    </MenuLinkWrapper>
  ) : (
    <MenuPopup
      menus={menus}
      onMenuClicked={(menuId) => onMenuClicked(menuId, row)}
    >
      <MenuIconBox>
        <Icon icon="Menu" size={30} />
      </MenuIconBox>
    </MenuPopup>
  )
}

export default TableMenu
